import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { FeedbackState, FeedbackCategory } from "../../Constants/feedbackEnums";
import FeedbackStateBadge from "../Common/FeedbackBadges/FeedbackStateBadge";
import FeedbackCategoryBadge from "../Common/FeedbackBadges/FeedbackCategoryBadge";
import { appPaths } from "../../../Common/Constants/appPaths";
import AuthorProfileBadge from "../../../User/Components/Common/AuthorProfileBadge";
import { AuthoredByData } from "../../../User";

type Props = {
  title: string;
  code: string;
  category: FeedbackCategory;
  state: FeedbackState;
  authorData?: AuthoredByData;
  dateCreated: Date;
  dateModified: Date | null;
  onDeleteConfirm: (code: string) => void;
};

export const DeleteFeedback: React.FC<Props> = props => (
  <Container fluid>
    <Row>
      <Col>
        <div>
          <div>
            <h2>Are you sure you want to delete this Feedback?</h2>
          </div>
          <hr />
          <div>
            <h3>{props.title}</h3>
          </div>
          <div>
            {!!props.authorData && (
              <>
                <AuthorProfileBadge authoredBy={props.authorData} />
                <span>&nbsp;</span>
              </>
            )}
            <FeedbackStateBadge state={props.state} />
            <span>&nbsp;</span>
            <FeedbackCategoryBadge category={props.category} />
            <span>&nbsp;</span>
          </div>
          <div>
            <small>
              Created at {props.dateCreated.toLocaleString()}{" "}
              {props.dateModified == null
                ? ""
                : `modified on ${props.dateModified.toLocaleString()}`}
              <span>&nbsp;</span>
              <Link to={appPaths.feedback.editFeedback.replace(":code", props.code)}>Edit</Link>
            </small>
          </div>
        </div>
        <div>{props.children}</div>
        <hr />
        <div>
          <Button
            className="btn-danger"
            onClick={() => {
              props.onDeleteConfirm(props.code);
            }}
          >
            Delete
          </Button>
        </div>
      </Col>
    </Row>
  </Container>
);
